<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <div class="row">
        <div class="col-xs-12">
          <h5>
            My Projects
          </h5>
        </div>

        <div class="col-xs-6">
          <SelectWidget
              v-model="horizon"
              class="form-control input-sm"
              :options="horizonOptions"
          />
        </div>

        <div class="col-xs-6">
          <SelectWidget
              v-model="portal"
              class="form-control input-sm"
              :nullable="true"
              placeholder="(all portals)"
              :options="portals.map(portal => ({value: portal.id, label: portal.attributes.name}))"
          />
        </div>
      </div>
    </div>

    <LoadingSpinner v-if="loading"/>

    <ul v-else class="list-group">
      <li v-for="project in projects" class="list-group-item" style="padding: 10px 0">
        <div style="display: flex; flex-direction: row">
          <div class="text-muted"
               style="flex-grow: 1; flex-basis: 0; font-size: 24px; display: flex; justify-content: center; align-items: center;">
            <i class="fa fa-project-diagram"></i>
          </div>

          <div style="flex-grow: 6; flex-basis: 0">
            <div>
              <router-link :to="'/projects/' + project.id">
                {{ project.attributes.name }}
              </router-link>

              <Avatar
                  v-for="manager in project.attributes.project_managers"
                  :key="manager.user_id"
                  :color="manager.user_color"
              >
                {{ manager.user_initials }}
              </Avatar>
            </div>

            <div>
              <i>
                {{ project.attributes.portal_name }} &middot; {{ project.attributes.project_category_name }}
              </i>
            </div>

            <div>
              You have been assigned to {{ getProjectLeadCount(project) }} leads.
            </div>

            {{ project.attributes.ends_at | date }}
          </div>
        </div>
      </li>

      <li v-if="projects.length === 0" class="list-group-item text-center" style="padding: 50px;">
        <i class="fa fa-project-diagram" style="font-size: 96px;"></i>

        <br><br>

        No projects match the selected filters.
      </li>
    </ul>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import store from '@/store'
import LoadingSpinner from "../../../Layout/LoadingSpinner.vue";
import SelectWidget from "../../../../vendor/forms/FormGroups/Widgets/Select.vue";
import Avatar from "../../../Avatar.vue";

export default {
  components: {Avatar, SelectWidget, LoadingSpinner},
  data() {
    return {
      projects: null,
      portals: [],

      portal: null,
      horizon: moment().add(90, "days").format('YYYY-MM-DD'),

      loading: true,

      shared: store
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    portal() {
      this.reload()
    },

    horizon() {
      this.reload()
    }
  },

  computed: {
    horizonOptions() {
      return [
        {value: moment().format('YYYY-MM-DD'), label: '(today)'},
        {value: moment().add(1, "days").format('YYYY-MM-DD'), label: '+1 days'},
        {value: moment().add(2, "days").format('YYYY-MM-DD'), label: '+2 days'},
        {value: moment().add(3, "days").format('YYYY-MM-DD'), label: '+3 days'},
        {value: moment().add(7, "days").format('YYYY-MM-DD'), label: '+7 days'},
        {value: moment().add(14, "days").format('YYYY-MM-DD'), label: '+14 days'},
        {value: moment().add(30, "days").format('YYYY-MM-DD'), label: '+30 days'},
        {value: moment().add(90, "days").format('YYYY-MM-DD'), label: '+90 days'},
        {value: null, label: 'All'}
      ]
    }
  },

  methods: {
    load() {
      Promise.all([
        this.getProjectPromise(),
        http.get("/api/v2/portals")
      ]).then(responses => {
        this.projects = responses[0].data.data

        this.portals = responses[1].data.data

        this.loading = false
      })
    },

    reload() {
      this.getProjectPromise().then(response => {
        this.projects = response.data.data
      })
    },

    getProjectPromise() {
      return http.get("/api/v2/projects", {
        'filter[status]': 'active',
        'filter[user_id]': this.shared.user.id,
        'filter[portal_id]': this.portal,
        'filter[ends_before]': this.horizon,
      })
    },

    getProjectLeadCount(project) {
      return project.attributes.project_leads.filter(projectLead => projectLead.user_id === this.shared.user.id).length
    }
  }
}
</script>
